import { lacrosselab } from '@labradorsports/constants';

export const SiteConfig = lacrosselab.SiteConfig;

export const GoogleAnalyticsID = 'G-7F6KTZDQZ1';

export const Sports = lacrosselab.Sports;

export const SportsNames = {
    [Sports.MensLax]: "Men's Lacrosse",
    [Sports.WomensLax]: "Women's Lacrosse",
    [Sports.BoxLax]: 'Box Lacrosse',
    [Sports.SixesLax]: 'Sixes Lacrosse',
};

export const PlayerPositions = {
    ATTACK: 'ATTACK',
    MIDFIELD: 'MIDFIELD',
    DEFENSE: 'DEFENSE',
    LSM: 'LSM',
    GOALKEEPER: 'GOALKEEPER',
    OFFMID: 'OFFMID',
    DEFMID: 'DEFMID',
    FORWARD: 'FORWARD',
    TRANSITION: 'TRANSITION',
    FACEOFF: 'FACEOFF',
};

export const PlayerPositionNames = {
    [PlayerPositions.ATTACK]: 'Attack',
    [PlayerPositions.MIDFIELD]: 'Midfield',
    [PlayerPositions.DEFENSE]: 'Defense',
    [PlayerPositions.LSM]: 'LSM',
    [PlayerPositions.GOALKEEPER]: 'Goalie',
    [PlayerPositions.OFFMID]: 'Offense Mid',
    [PlayerPositions.DEFMID]: 'Defense Mid',
    [PlayerPositions.FACEOFF]: 'Face-Off',
    [PlayerPositions.FORWARD]: 'Forward',
    [PlayerPositions.TRANSITION]: 'Transition',
};

export const SportPositions = {
    [Sports.MensLax]: [
        PlayerPositions.ATTACK,
        PlayerPositions.MIDFIELD,
        PlayerPositions.DEFENSE,
        PlayerPositions.LSM,
        PlayerPositions.GOALKEEPER,
        PlayerPositions.OFFMID,
        PlayerPositions.DEFMID,
        PlayerPositions.FACEOFF,
    ],
    [Sports.WomensLax]: [
        PlayerPositions.ATTACK,
        PlayerPositions.MIDFIELD,
        PlayerPositions.DEFENSE,
        PlayerPositions.GOALKEEPER,
    ],
    [Sports.BoxLax]: [
        PlayerPositions.FORWARD,
        PlayerPositions.TRANSITION,
        PlayerPositions.DEFENSE,
        PlayerPositions.GOALKEEPER,
    ],
    [Sports.SixesLax]: [
        PlayerPositions.FORWARD,
        PlayerPositions.TRANSITION,
        PlayerPositions.DEFENSE,
        PlayerPositions.GOALKEEPER,
    ],
};

export const EvaluationCriteria = {
    SPEED: 'SPEED',
    AGILITY: 'AGILITY',
    STRENGTH: 'STRENGTH',
    STICK_STRONG: 'STICK_STRONG',
    STICK_WEAK: 'STICK_WEAK',
    SHOOT_WEAK: 'SHOOT_WEAK',
    SHOOT_STRONG: 'SHOOT_STRONG',
    GROUNDBALLS: 'GROUNDBALLS',
    OFFENSE_IQ: 'OFFENSE_IQ',
    DEFENSE_IQ: 'DEFENSE_IQ',
    OFFENSE_TRANSITION: 'OFFENSE_TRANSITION',
    DEFENSE_TRANSITION: 'DEFENSE_TRANSITION',
    SAVING: 'SAVING',
    COMMUNICATION: 'COMMUNICATION',
    GRIT: 'GRIT',
    CHECKING: 'CHECKING',
    FACE_OFF: 'FACE_OFF',
};

export const AttackRatingWeights = {
    [EvaluationCriteria.SPEED]: 9.5,
    [EvaluationCriteria.AGILITY]: 9.5,
    [EvaluationCriteria.STRENGTH]: 6.3,
    [EvaluationCriteria.STICK_STRONG]: 10.5,
    [EvaluationCriteria.STICK_WEAK]: 8.4,
    [EvaluationCriteria.SHOOT_WEAK]: 7.4,
    [EvaluationCriteria.SHOOT_STRONG]: 9.5,
    [EvaluationCriteria.GROUNDBALLS]: 5.3,
    [EvaluationCriteria.OFFENSE_IQ]: 10.5,
    [EvaluationCriteria.DEFENSE_IQ]: 1.1,
    [EvaluationCriteria.OFFENSE_TRANSITION]: 8.4,
    [EvaluationCriteria.DEFENSE_TRANSITION]: 3.2,
    [EvaluationCriteria.SAVING]: 0,
    [EvaluationCriteria.COMMUNICATION]: 5.3,
    [EvaluationCriteria.GRIT]: 5.3,
    [EvaluationCriteria.CHECKING]: 0,
    [EvaluationCriteria.FACE_OFF]: 0,
};

export const DefenseRatingWeights = {
    SPEED: 8.8,
    AGILITY: 11,
    STRENGTH: 10,
    STICK_STRONG: 5.5,
    STICK_WEAK: 1.1,
    SHOOT_WEAK: 0,
    SHOOT_STRONG: 1.1,
    GROUNDBALLS: 10,
    OFFENSE_IQ: 1.1,
    DEFENSE_IQ: 11,
    OFFENSE_TRANSITION: 5.5,
    DEFENSE_TRANSITION: 5.5,
    SAVING: 0.6,
    COMMUNICATION: 10,
    GRIT: 8.8,
    CHECKING: 10,
    FACE_OFF: 0,
};

export const LSMRatingWeights = {
    SPEED: 9.3,
    AGILITY: 9.3,
    STRENGTH: 7.3,
    STICK_STRONG: 7.3,
    STICK_WEAK: 4.1,
    SHOOT_WEAK: 0,
    SHOOT_STRONG: 3.1,
    GROUNDBALLS: 9.3,
    OFFENSE_IQ: 2.1,
    DEFENSE_IQ: 9.3,
    OFFENSE_TRANSITION: 6.2,
    DEFENSE_TRANSITION: 5.2,
    SAVING: 0.5,
    COMMUNICATION: 9.3,
    GRIT: 8.3,
    CHECKING: 9.3,
    FACE_OFF: 0,
};

export const GoalkeeperRatingWeights = {
    SPEED: 1.4,
    AGILITY: 11.1,
    STRENGTH: 1.4,
    STICK_STRONG: 9.7,
    STICK_WEAK: 0,
    SHOOT_WEAK: 0,
    SHOOT_STRONG: 0,
    GROUNDBALLS: 9.7,
    OFFENSE_IQ: 0,
    DEFENSE_IQ: 13.9,
    OFFENSE_TRANSITION: 8.3,
    DEFENSE_TRANSITION: 4.2,
    SAVING: 13.9,
    COMMUNICATION: 13.9,
    GRIT: 11.1,
    CHECKING: 1.4,
    FACE_OFF: 0,
};

export const MidfieldRatingWeights = {
    [EvaluationCriteria.SPEED]: 8.4,
    [EvaluationCriteria.AGILITY]: 8.4,
    [EvaluationCriteria.STRENGTH]: 4.7,
    [EvaluationCriteria.STICK_STRONG]: 7.5,
    [EvaluationCriteria.STICK_WEAK]: 6.5,
    [EvaluationCriteria.SHOOT_WEAK]: 4.7,
    [EvaluationCriteria.SHOOT_STRONG]: 6.5,
    [EvaluationCriteria.GROUNDBALLS]: 6.5,
    [EvaluationCriteria.OFFENSE_IQ]: 6.5,
    [EvaluationCriteria.DEFENSE_IQ]: 6.5,
    [EvaluationCriteria.OFFENSE_TRANSITION]: 9.3,
    [EvaluationCriteria.DEFENSE_TRANSITION]: 9.3,
    [EvaluationCriteria.SAVING]: 0.5,
    [EvaluationCriteria.COMMUNICATION]: 5.6,
    [EvaluationCriteria.GRIT]: 8.4,
    [EvaluationCriteria.CHECKING]: 0.5,
    [EvaluationCriteria.FACE_OFF]: 0,
};

export const OffMidRatingWeights = {
    SPEED: 8.9,
    AGILITY: 7.9,
    STRENGTH: 5,
    STICK_STRONG: 10,
    STICK_WEAK: 6.9,
    SHOOT_WEAK: 5.9,
    SHOOT_STRONG: 7.9,
    GROUNDBALLS: 6.9,
    OFFENSE_IQ: 7.9,
    DEFENSE_IQ: 5,
    OFFENSE_TRANSITION: 7.9,
    DEFENSE_TRANSITION: 5.9,
    SAVING: 0,
    COMMUNICATION: 5.9,
    GRIT: 6.9,
    CHECKING: 1,
    FACE_OFF: 0,
};

export const DefMidRatingWeights = {
    SPEED: 9.2,
    AGILITY: 9.2,
    STRENGTH: 7.2,
    STICK_STRONG: 7.2,
    STICK_WEAK: 5.1,
    SHOOT_WEAK: 3.1,
    SHOOT_STRONG: 6.2,
    GROUNDBALLS: 9.2,
    OFFENSE_IQ: 3.1,
    DEFENSE_IQ: 8.2,
    OFFENSE_TRANSITION: 8.2,
    DEFENSE_TRANSITION: 6.2,
    SAVING: 0.51,
    COMMUNICATION: 7.2,
    GRIT: 8.2,
    CHECKING: 2.1,
    FACE_OFF: 0,
};

export const FaceOffRatingWeights = {
    [EvaluationCriteria.SPEED]: 3.5,
    [EvaluationCriteria.AGILITY]: 5,
    [EvaluationCriteria.STRENGTH]: 4,
    [EvaluationCriteria.FACE_OFF]: 10,
    [EvaluationCriteria.STICK_STRONG]: 4,
    [EvaluationCriteria.STICK_WEAK]: 1.5,
    [EvaluationCriteria.SHOOT_STRONG]: 0.5,
    [EvaluationCriteria.SHOOT_WEAK]: 0,
    [EvaluationCriteria.GROUNDBALLS]: 4,
    [EvaluationCriteria.CHECKING]: 0.5,
    [EvaluationCriteria.SAVING]: 0.5,
    [EvaluationCriteria.OFFENSE_IQ]: 0.5,
    [EvaluationCriteria.DEFENSE_IQ]: 1.5,
    [EvaluationCriteria.OFFENSE_TRANSITION]: 3.5,
    [EvaluationCriteria.DEFENSE_TRANSITION]: 3.5,
    [EvaluationCriteria.COMMUNICATION]: 2.5,
    [EvaluationCriteria.GRIT]: 5,
};

export const PlayerRatingWeights = {
    [PlayerPositions.ATTACK]: AttackRatingWeights,
    [PlayerPositions.MIDFIELD]: MidfieldRatingWeights,
    [PlayerPositions.DEFENSE]: DefenseRatingWeights,
    [PlayerPositions.LSM]: LSMRatingWeights,
    [PlayerPositions.GOALKEEPER]: GoalkeeperRatingWeights,
    [PlayerPositions.OFFMID]: OffMidRatingWeights,
    [PlayerPositions.DEFMID]: DefMidRatingWeights,
    [PlayerPositions.FACEOFF]: FaceOffRatingWeights,
    [PlayerPositions.FORWARD]: AttackRatingWeights,
    [PlayerPositions.TRANSITION]: MidfieldRatingWeights,
};

export const PlayerRatingSections = [
    {
        id: 'athleticism',
        sectionName: 'Athleticism',
        criteria: [
            { id: EvaluationCriteria.SPEED, criteriaLabel: 'Speed' },
            { id: EvaluationCriteria.AGILITY, criteriaLabel: 'Agility' },
            { id: EvaluationCriteria.STRENGTH, criteriaLabel: 'Strength' },
        ],
    },
    {
        id: 'skills',
        sectionName: 'Skills',
        criteria: [
            { id: EvaluationCriteria.FACE_OFF, criteriaLabel: 'Face-Off' },
            { id: EvaluationCriteria.STICK_STRONG, criteriaLabel: 'Stick (Strong)' },
            { id: EvaluationCriteria.STICK_WEAK, criteriaLabel: 'Stick (Weak)' },
            { id: EvaluationCriteria.SHOOT_STRONG, criteriaLabel: 'Shoot (Strong)' },
            { id: EvaluationCriteria.SHOOT_WEAK, criteriaLabel: 'Shoot (Weak)' },
            { id: EvaluationCriteria.GROUNDBALLS, criteriaLabel: 'Groundballs' },
            { id: EvaluationCriteria.CHECKING, criteriaLabel: 'Checking' },
            { id: EvaluationCriteria.SAVING, criteriaLabel: 'Saving' },
        ],
    },
    {
        id: 'awareness',
        sectionName: 'Awareness',
        criteria: [
            { id: EvaluationCriteria.OFFENSE_IQ, criteriaLabel: 'Offense IQ' },
            { id: EvaluationCriteria.DEFENSE_IQ, criteriaLabel: 'Defense IQ' },
            { id: EvaluationCriteria.OFFENSE_TRANSITION, criteriaLabel: 'Offense Transition (Clearing)' },
            { id: EvaluationCriteria.DEFENSE_TRANSITION, criteriaLabel: 'Defense Transition (Riding)' },
        ],
    },
    {
        id: 'intangibles',
        sectionName: 'Intangibles',
        criteria: [
            { id: EvaluationCriteria.COMMUNICATION, criteriaLabel: 'Communication' },
            { id: EvaluationCriteria.GRIT, criteriaLabel: 'Grit' },
        ],
    },
];

export const PlayTags = [
    'Offense',
    'Extra-Man',
    'Defense',
    'Man-Down',
    'Ride',
    'Clear',
    'Face-Off',
    'Stick-Work',
    'Read-and-React',
    'Transition',
];

export const DepthSections = {
    attack: 'attack',
    midfield: 'midfield',
    faceoff: 'faceoff',
    ssdm: 'ssdm',
    lsm: 'lsm',
    defense: 'defense',
    goal: 'goal',
    manup: 'manup',
    mandown: 'mandown',
    forward: 'forward',
    transition: 'transition',
};

export const DepthConfig = {
    [Sports.MensLax]: {
        [DepthSections.attack]: {
            name: 'Attack',
            starters: 3,
        },
        [DepthSections.midfield]: {
            name: 'Midfield',
            starters: 3,
            maxLines: 3,
            linesKey: 'midLines',
        },
        [DepthSections.faceoff]: {
            name: 'Face-Off',
            starters: 1,
            optional: true,
        },
        [DepthSections.ssdm]: {
            name: 'Short Stick Defensive Midfield',
            shortName: 'SSDM',
            starters: 1,
            optional: true,
        },
        [DepthSections.lsm]: {
            name: 'Long Stick Midfield',
            starters: 1,
        },
        [DepthSections.defense]: {
            name: 'Defense',
            starters: 3,
        },
        [DepthSections.goal]: {
            name: 'Goalkeeper',
            starters: 1,
        },
        [DepthSections.manup]: {
            name: 'Man-Up',
            starters: 6,
        },
        [DepthSections.mandown]: {
            name: 'Man-Down',
            starters: 5,
        },
    },
    [Sports.WomensLax]: {
        [DepthSections.attack]: {
            name: 'Attack',
            starters: 4,
        },
        [DepthSections.midfield]: {
            name: 'Midfield',
            starters: 3,
            maxLines: 3,
            linesKey: 'midLines',
        },
        [DepthSections.defense]: {
            name: 'Defense',
            starters: 4,
        },
        [DepthSections.goal]: {
            name: 'Goalkeeper',
            starters: 1,
        },
    },
    [Sports.BoxLax]: {
        [DepthSections.forward]: {
            name: 'Forward',
            starters: 3,
        },
        [DepthSections.transition]: {
            name: 'Transition',
            starters: 3,
            maxLines: 3,
        },
        [DepthSections.defense]: {
            name: 'Defense',
            starters: 3,
        },
        [DepthSections.goal]: {
            name: 'Goalkeeper',
            starters: 1,
        },
    },
    [Sports.SixesLax]: {
        [DepthSections.forward]: {
            name: 'Forward',
            starters: 3,
        },
        [DepthSections.transition]: {
            name: 'Transition',
            starters: 3,
            maxLines: 3,
        },
        [DepthSections.defense]: {
            name: 'Defense',
            starters: 3,
        },
        [DepthSections.goal]: {
            name: 'Goalkeeper',
            starters: 1,
        },
    },
};

export const DepthChartLayout = {
    [Sports.MensLax]: [
        [DepthSections.attack, DepthSections.manup],
        [DepthSections.midfield],
        [DepthSections.faceoff, DepthSections.ssdm, DepthSections.lsm],
        [DepthSections.defense, DepthSections.mandown, DepthSections.goal],
    ],
    [Sports.WomensLax]: [
        [DepthSections.attack],
        [DepthSections.midfield],
        [DepthSections.defense],
        [DepthSections.goal],
    ],
    [Sports.BoxLax]: [
        [DepthSections.forward],
        [DepthSections.transition],
        [DepthSections.defense],
        [DepthSections.goal],
    ],
    [Sports.SixesLax]: [
        [DepthSections.forward],
        [DepthSections.transition],
        [DepthSections.defense],
        [DepthSections.goal],
    ],
};

export const PlayerRoleNames = {
    [PlayerPositions.ATTACK]: 'Attack',
    [PlayerPositions.DEFENSE]: 'Defense',
    [PlayerPositions.GOALKEEPER]: 'Goalkeeper',
    [PlayerPositions.LSM]: 'Long-Stick Midfield',
    [PlayerPositions.MIDFIELD]: 'Midfield',
    [PlayerPositions.FACEOFF]: 'Face-Off',
};

export const TeamSizes = lacrosselab.TeamSizes;

export const PlanNames = lacrosselab.PlanNames;

export const AddonConfig = lacrosselab.AddonConfig;

export const AttendanceDisplayGroups = {
    [Sports.MensLax]: [
        [PlayerPositions.ATTACK],
        [PlayerPositions.DEFENSE],
        [
            PlayerPositions.MIDFIELD,
            PlayerPositions.OFFMID,
            PlayerPositions.DEFMID,
            PlayerPositions.LSM,
            PlayerPositions.FACEOFF,
        ],
        [PlayerPositions.GOALKEEPER],
    ],
    [Sports.WomensLax]: [
        [PlayerPositions.ATTACK],
        [PlayerPositions.DEFENSE],
        [PlayerPositions.MIDFIELD],
        [PlayerPositions.GOALKEEPER],
    ],
    [Sports.BoxLax]: [
        [PlayerPositions.FORWARD],
        [PlayerPositions.DEFENSE],
        [PlayerPositions.TRANSITION],
        [PlayerPositions.GOALKEEPER],
    ],
    [Sports.SixesLax]: [
        [PlayerPositions.FORWARD],
        [PlayerPositions.DEFENSE],
        [PlayerPositions.TRANSITION],
        [PlayerPositions.GOALKEEPER],
    ],
};

export const ScoutingReportStats = {
    // Common
    GAMES: 'GAMES',
    GAMES_STARTED: 'GAMES_STARTED',
    GOALS: 'GOALS',
    GOALS_PER_GAME: 'GOALS_PER_GAME',
    ASSISTS: 'ASSISTS',
    SHOTS: 'SHOTS',
    SHOT_PERCENTAGE: 'SHOT_PERCENTAGE',
    SHOTS_ON_GOAL: 'SHOTS_ON_GOAL',
    SHOTS_ON_GOAL_PCT: 'SHOTS_ON_GOAL_PCT',
    SHOTS_PER_GAME: 'SHOTS_PER_GAME',
    OVERTIME: 'OVERTIME',
    GROUNDBALLS: 'GROUNDBALLS',
    TURNOVERS: 'TURNOVERS',
    CAUSED_TURNOVERS: 'CAUSED_TURNOVERS',
    CLEARS: 'CLEARS',
    CLEAR_PCT: 'CLEAR_PCT',

    // Men's Only
    MAN_UP: 'MAN_UP',
    MAN_DOWN: 'MAN_DOWN',
    FACEOFFS_W_L: 'FACEOFFS_W_L',
    FACEOFFS_PCT: 'FACEOFFS_PCT',
    PENALTIES: 'PENALTIES',
    PENALTY_MINUTES: 'PENALTY_MINUTES',

    // Women's Only
    FREE_POSITION: 'FREE_POSITION',
    WOMAN_UP: 'WOMAN_UP',
    WOMAN_DOWN: 'WOMAN_DOWN',
    FREE_POSITION_MADE_ATTEMPTS: 'FREE_POSITION_MADE_ATTEMPTS',
    FREE_POSITION_PCT: 'FREE_POSITION_PCT',
    DRAW_CONTROLS: 'DRAW_CONTROLS',
    FOULS: 'FOULS',
};

export const ScoutingReportStatDetails = {
    [ScoutingReportStats.GAMES]: {
        key: ScoutingReportStats.GAMES,
        name: 'Games',
        shortKey: 'GP',
    },
    [ScoutingReportStats.GAMES_STARTED]: {
        key: ScoutingReportStats.GAMES_STARTED,
        name: 'Games Started',
        shortKey: 'GS',
    },
    [ScoutingReportStats.GOALS]: {
        key: ScoutingReportStats.GOALS,
        shortKey: 'G',
        name: 'Goals',
    },
    [ScoutingReportStats.GOALS_PER_GAME]: {
        key: ScoutingReportStats.GOALS_PER_GAME,
        name: 'Goals per Game',
        formula: [ScoutingReportStats.GOALS, '/', ScoutingReportStats.GAMES],
    },
    [ScoutingReportStats.ASSISTS]: {
        key: ScoutingReportStats.ASSISTS,
        shortKey: 'AST',
        name: 'Assists',
    },
    [ScoutingReportStats.SHOTS]: { key: ScoutingReportStats.SHOTS, name: 'Shots' },
    [ScoutingReportStats.SHOT_PERCENTAGE]: {
        key: ScoutingReportStats.SHOT_PERCENTAGE,
        name: 'Shot Percentage',
        formula: [ScoutingReportStats.GOALS, '/', ScoutingReportStats.SHOTS],
        format: '%',
    },
    [ScoutingReportStats.SHOTS_ON_GOAL]: {
        key: ScoutingReportStats.SHOTS_ON_GOAL,
        name: 'Shots on Goal',
    },
    [ScoutingReportStats.SHOTS_ON_GOAL_PCT]: {
        key: ScoutingReportStats.SHOTS_ON_GOAL_PCT,
        name: 'Shots on Goal Percentage',
        formula: [ScoutingReportStats.SHOTS_ON_GOAL, '/', ScoutingReportStats.SHOTS],
        format: '%',
    },
    [ScoutingReportStats.SHOTS_PER_GAME]: {
        key: ScoutingReportStats.SHOTS_PER_GAME,
        name: 'Shots per Game',
        formula: [ScoutingReportStats.SHOTS, '/', ScoutingReportStats.GAMES],
    },
    [ScoutingReportStats.MAN_UP]: { key: ScoutingReportStats.MAN_UP, name: 'Man-up' },
    [ScoutingReportStats.MAN_DOWN]: { key: ScoutingReportStats.MAN_DOWN, name: 'Man-down' },
    [ScoutingReportStats.OVERTIME]: { key: ScoutingReportStats.OVERTIME, name: 'Overtime' },
    [ScoutingReportStats.GROUNDBALLS]: {
        key: ScoutingReportStats.GROUNDBALLS,
        shortKey: 'GB',
        name: 'Ground Balls',
    },
    [ScoutingReportStats.TURNOVERS]: {
        key: ScoutingReportStats.TURNOVERS,
        shortKey: 'TO',
        name: 'Turnovers',
        lowerIsBetter: true,
    },
    [ScoutingReportStats.CAUSED_TURNOVERS]: {
        key: ScoutingReportStats.CAUSED_TURNOVERS,
        name: 'Caused Turnovers',
    },
    [ScoutingReportStats.FACEOFFS_W_L]: {
        key: ScoutingReportStats.FACEOFFS_W_L,
        name: 'Faceoffs: W-L',
        format: '-',
    },
    [ScoutingReportStats.FACEOFFS_PCT]: {
        key: ScoutingReportStats.FACEOFFS_PCT,
        name: 'Faceoffs: Percentage',
        formula: ['a-b', ScoutingReportStats.FACEOFFS_W_L, 'a', '/', 'ab'],
        format: '%',
    },
    [ScoutingReportStats.CLEARS]: { key: ScoutingReportStats.CLEARS, name: 'Clears' },
    [ScoutingReportStats.CLEAR_PCT]: {
        key: ScoutingReportStats.CLEAR_PCT,
        name: 'Clear Percentage',
    },
    [ScoutingReportStats.PENALTIES]: {
        key: ScoutingReportStats.PENALTIES,
        name: 'Penalties',
        lowerIsBetter: true,
    },
    [ScoutingReportStats.PENALTY_MINUTES]: {
        key: ScoutingReportStats.PENALTY_MINUTES,
        name: 'Penalty Minutes',
        format: 'mm:ss',
        lowerIsBetter: true,
    },

    [ScoutingReportStats.WOMAN_UP]: { key: ScoutingReportStats.WOMAN_UP, name: 'Woman-up' },
    [ScoutingReportStats.WOMAN_DOWN]: {
        key: ScoutingReportStats.WOMAN_DOWN,
        name: 'Woman-down',
    },
    [ScoutingReportStats.FREE_POSITION_MADE_ATTEMPTS]: {
        key: ScoutingReportStats.FREE_POSITION_MADE_ATTEMPTS,
        name: 'Free Position: Made-Attempts',
        format: '-',
    },
    [ScoutingReportStats.FREE_POSITION]: {
        key: ScoutingReportStats.FREE_POSITION,
        name: 'Free Position',
    },
    [ScoutingReportStats.FREE_POSITION_PCT]: {
        key: ScoutingReportStats.FREE_POSITION_PCT,
        name: 'Free Position: Percentage',
        formula: ['a-b', ScoutingReportStats.FREE_POSITION_MADE_ATTEMPTS, 'a', '/', 'b'],
        format: '%',
    },
    [ScoutingReportStats.DRAW_CONTROLS]: {
        key: ScoutingReportStats.DRAW_CONTROLS,
        name: 'Draw Controls',
    },
    [ScoutingReportStats.FOULS]: {
        key: ScoutingReportStats.FOULS,
        name: 'Fouls',
    },
};

export const ScoutingReportStatDisplay = {
    [Sports.MensLax]: [
        {
            categoryName: 'PREVIEW',
            stats: [ScoutingReportStats.GAMES, ScoutingReportStats.GOALS, ScoutingReportStats.GOALS_PER_GAME],
        },
        {
            categoryName: 'Scoring',
            stats: [
                ScoutingReportStats.GAMES,
                ScoutingReportStats.GOALS,
                ScoutingReportStats.GOALS_PER_GAME,
                ScoutingReportStats.ASSISTS,
                ScoutingReportStats.SHOTS,
                ScoutingReportStats.SHOT_PERCENTAGE,
                ScoutingReportStats.SHOTS_ON_GOAL,
                ScoutingReportStats.SHOTS_ON_GOAL_PCT,
                ScoutingReportStats.SHOTS_PER_GAME,
            ],
        },
        {
            categoryName: 'Goal Breakdown',
            stats: [ScoutingReportStats.MAN_UP, ScoutingReportStats.MAN_DOWN, ScoutingReportStats.OVERTIME],
        },
        {
            categoryName: 'Miscellaneous',
            stats: [
                ScoutingReportStats.GROUNDBALLS,
                ScoutingReportStats.TURNOVERS,
                ScoutingReportStats.CAUSED_TURNOVERS,
                ScoutingReportStats.FACEOFFS_W_L,
                ScoutingReportStats.FACEOFFS_PCT,
                ScoutingReportStats.CLEARS,
                ScoutingReportStats.CLEAR_PCT,
                ScoutingReportStats.PENALTIES,
                ScoutingReportStats.PENALTY_MINUTES,
            ],
        },
    ],
    [Sports.WomensLax]: [
        {
            categoryName: 'PREVIEW',
            stats: [ScoutingReportStats.GAMES, ScoutingReportStats.GOALS, ScoutingReportStats.GOALS_PER_GAME],
        },
        {
            categoryName: 'Scoring',
            stats: [
                ScoutingReportStats.GAMES,
                ScoutingReportStats.GOALS,
                ScoutingReportStats.GOALS_PER_GAME,
                ScoutingReportStats.ASSISTS,
                ScoutingReportStats.SHOTS,
                ScoutingReportStats.SHOT_PERCENTAGE,
                ScoutingReportStats.SHOTS_ON_GOAL,
                ScoutingReportStats.SHOTS_ON_GOAL_PCT,
                ScoutingReportStats.SHOTS_PER_GAME,
            ],
        },
        {
            categoryName: 'Goal Breakdown',
            stats: [
                ScoutingReportStats.FREE_POSITION,
                ScoutingReportStats.WOMAN_UP,
                ScoutingReportStats.WOMAN_DOWN,
                ScoutingReportStats.OVERTIME,
            ],
        },
        {
            categoryName: 'Free Position Opportunites',
            stats: [ScoutingReportStats.FREE_POSITION_MADE_ATTEMPTS, ScoutingReportStats.FREE_POSITION_PCT],
        },
        {
            categoryName: 'Miscellaneous',
            stats: [
                ScoutingReportStats.GROUNDBALLS,
                ScoutingReportStats.TURNOVERS,
                ScoutingReportStats.CAUSED_TURNOVERS,
                ScoutingReportStats.DRAW_CONTROLS,
                ScoutingReportStats.CLEARS,
                ScoutingReportStats.CLEAR_PCT,
            ],
        },
    ],
    [Sports.BoxLax]: [
        {
            categoryName: 'PREVIEW',
            stats: [ScoutingReportStats.GAMES, ScoutingReportStats.GOALS, ScoutingReportStats.GOALS_PER_GAME],
        },
        {
            categoryName: 'Scoring',
            stats: [
                ScoutingReportStats.GAMES,
                ScoutingReportStats.GOALS,
                ScoutingReportStats.GOALS_PER_GAME,
                ScoutingReportStats.ASSISTS,
                ScoutingReportStats.SHOTS,
                ScoutingReportStats.SHOT_PERCENTAGE,
                ScoutingReportStats.SHOTS_ON_GOAL,
                ScoutingReportStats.SHOTS_ON_GOAL_PCT,
                ScoutingReportStats.SHOTS_PER_GAME,
            ],
        },
        {
            categoryName: 'Goal Breakdown',
            stats: [
                ScoutingReportStats.FREE_POSITION,
                ScoutingReportStats.WOMAN_UP,
                ScoutingReportStats.WOMAN_DOWN,
                ScoutingReportStats.OVERTIME,
            ],
        },
        {
            categoryName: 'Free Position Opportunites',
            stats: [ScoutingReportStats.FREE_POSITION_MADE_ATTEMPTS, ScoutingReportStats.FREE_POSITION_PCT],
        },
        {
            categoryName: 'Miscellaneous',
            stats: [
                ScoutingReportStats.GROUNDBALLS,
                ScoutingReportStats.TURNOVERS,
                ScoutingReportStats.CAUSED_TURNOVERS,
                ScoutingReportStats.DRAW_CONTROLS,
                ScoutingReportStats.CLEARS,
                ScoutingReportStats.CLEAR_PCT,
            ],
        },
    ],
    [Sports.SixesLax]: [
        {
            categoryName: 'PREVIEW',
            stats: [ScoutingReportStats.GAMES, ScoutingReportStats.GOALS, ScoutingReportStats.GOALS_PER_GAME],
        },
        {
            categoryName: 'Scoring',
            stats: [
                ScoutingReportStats.GAMES,
                ScoutingReportStats.GOALS,
                ScoutingReportStats.GOALS_PER_GAME,
                ScoutingReportStats.ASSISTS,
                ScoutingReportStats.SHOTS,
                ScoutingReportStats.SHOT_PERCENTAGE,
                ScoutingReportStats.SHOTS_ON_GOAL,
                ScoutingReportStats.SHOTS_ON_GOAL_PCT,
                ScoutingReportStats.SHOTS_PER_GAME,
            ],
        },
        {
            categoryName: 'Goal Breakdown',
            stats: [
                ScoutingReportStats.FREE_POSITION,
                ScoutingReportStats.WOMAN_UP,
                ScoutingReportStats.WOMAN_DOWN,
                ScoutingReportStats.OVERTIME,
            ],
        },
        {
            categoryName: 'Free Position Opportunites',
            stats: [ScoutingReportStats.FREE_POSITION_MADE_ATTEMPTS, ScoutingReportStats.FREE_POSITION_PCT],
        },
        {
            categoryName: 'Miscellaneous',
            stats: [
                ScoutingReportStats.GROUNDBALLS,
                ScoutingReportStats.TURNOVERS,
                ScoutingReportStats.CAUSED_TURNOVERS,
                ScoutingReportStats.DRAW_CONTROLS,
                ScoutingReportStats.CLEARS,
                ScoutingReportStats.CLEAR_PCT,
            ],
        },
    ],
};

export const PersonnelQuickStats = [
    ScoutingReportStats.GAMES,
    ScoutingReportStats.GOALS,
    ScoutingReportStats.ASSISTS,
    ScoutingReportStats.GROUNDBALLS,
    ScoutingReportStats.TURNOVERS,
];

export const Features = lacrosselab.Features;

const Config: ConfigSpec = {
    SiteConfig,
    GoogleAnalyticsID,
    Sports,
    PlayTags,
    SportsNames,
    PlayerPositions,
    PlayerRatingWeights,
    DepthSections,
    DepthConfig,
    DepthChartLayout,
    PlayerPositionNames,
    PlayerRatingSections,
    SportPositions,
    PlayerRoleNames,
    TeamSizes,
    PlanNames,
    AddonConfig,
    AttendanceDisplayGroups,
    ScoutingReportStats,
    ScoutingReportStatDetails,
    ScoutingReportStatDisplay,
    PersonnelQuickStats,
    Features,
};

export default Config;
